<script setup lang="ts">
import VAffiliateProfileUpdateForm from '@modules/affiliates-approved/submodules/affiliate-profile/components/VAffiliateProfileUpdateForm/VAffiliateProfileUpdateForm.vue';
import { useAffiliateProfileUpdate } from '@modules/affiliates-approved/submodules/affiliate-profile/composables';
import { AFFILIATES_APPROVED_PROFILE_PERMISSIONS } from '@modules/affiliates-approved/submodules/affiliate-profile/constants';

import { TRANSLATION_GROUP_AFFILIATE_PROFILE_SUBAFFILIATE } from '../../constants';

const {
  subaffiliateSchema,
  subaffiliateErrors,
  isOptionsLoading,
  isSubaffiliateUpdateLoading,
  onSubmitSubaffiliate,
  clearSubaffiliateError,
} = useAffiliateProfileUpdate(TRANSLATION_GROUP_AFFILIATE_PROFILE_SUBAFFILIATE);
</script>

<template>
  <VAffiliateProfileUpdateForm v-data-qa-auto-id="'ProfileSubaffiliatePage'"
    :form-schema="subaffiliateSchema"
    :errors="subaffiliateErrors"
    :readonly="!$hasPermission(AFFILIATES_APPROVED_PROFILE_PERMISSIONS.INVITATIONS_EDIT)"
    :is-data-loading="isOptionsLoading"
    :is-update-loading="isSubaffiliateUpdateLoading"
    @submit="onSubmitSubaffiliate"
    @interacted="clearSubaffiliateError"
  />
</template>
